import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-vod-display-interactive-format-specific',
  templateUrl: './vod-display-interactive-format-specific.component.html',
  styleUrls: ['./vod-display-interactive-format-specific.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VodDisplayInteractiveFormatSpecificComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: VodDisplayInteractiveFormatSpecificComponent,
      multi: true
    }
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class VodDisplayInteractiveFormatSpecificComponent implements OnInit, ControlValueAccessor {
  static DEFAULTS = {
    encrypt: true,
  };

  @Input()
  parentForm: FormGroup<any>;

  form: FormGroup;

  changed: any = () => {};
  touched: any = () => {};

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      encrypt: true,
    });

    this.form.valueChanges.subscribe((val) => {
      this.touched();
      this.changed({...val});
    });
  }

  ngOnInit(): void {}

  writeValue(value: any): void {
    if (value) {
      this.form.patchValue(value, {emitEvent: false});
    }
  }

  registerOnChange(fn: any): void {
    this.changed = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  validate(control: FormControl) {
    const isNotValid = !this.form.valid;
    return isNotValid && {
      invalid: true
    };
  }
}

